import React, { useEffect, useState } from "react";
import {  useNavigate } from "react-router-dom";
import { IMAGES } from "../constants/theme";
import NewsLetter from "../elements/NewsLetter";
import PageTitle from "../elements/PageTitle";

const API_BASE = process.env.REACT_APP_API_BASE_URL;
const API_URL = `${API_BASE}/courses/Packages/healthy-packages`;
console.log("base",API_BASE);
console.log("url",API_URL);
const Healthy = () => {
  const navigate = useNavigate();
  const [healthy, setHealthy] = useState([]);
  const [pricePlans, setPricePlans] = useState({});
  const [pricePlansOriginal, setPricePlansOriginal] = useState({});
  const [promotion, setPromotion] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  // Handle View Details click - check subscription first
  const handleViewDetails = async (e, packageId) => {
    e.preventDefault();
    
    const token = localStorage.getItem("token");
    
    // Check if user is logged in
    if (!token) {
      // Show message to user
      alert("Please login to view package details.");
      // Store the intended destination for redirect after login
      localStorage.setItem("redirectAfterLogin", `/Healthy/Package/${packageId}`);
      navigate("/login");
      return;
    }

    try {
      // Check subscription status for this package
      const res = await fetch(`${API_BASE}/courses/Packages/healthy-packages/${packageId}`, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      });

      if (res.status === 401) {
        navigate("/login");
        return;
      }

      if (res.status === 403) {
        const errorData = await res.json().catch(() => ({}));
        // Redirect to pricing page to renew subscription
        navigate(`/Healthy/Healthy-Pricing/${packageId}`);
        return;
      }

      if (!res.ok) {
        const errorData = await res.json().catch(() => ({}));
        throw new Error(errorData.error || "Failed to check subscription status");
      }

      const data = await res.json();
      
      // If user doesn't have subscription, redirect to pricing page with package ID
      if (!data.hasSubscription) {
        navigate(`/Healthy/Healthy-Pricing/${packageId}`);
        return;
      }

      // If user has subscription, navigate to details page
      navigate(`/Healthy/Package/${packageId}`);
    } catch (err) {
      console.error("Error checking subscription:", err);
      alert(err.message || "Error checking subscription. Please try again.");
    }
  };

  useEffect(() => {
    async function fetchHealthy() {
      try {
        setLoading(true);
        const res = await fetch(API_URL, {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
          },
        });

        if (!res.ok) throw new Error("Failed to fetch healthy packages");

        const data = await res.json();
        setHealthy(data.packages || []);
        setPricePlans(data.pricePlans || {});
        setPricePlansOriginal(data.pricePlansOriginal || {});
        setPromotion(data.promotion);
      } catch (err) {
        console.error(err);
        setError(err.message);
      } finally {
        setLoading(false);
      }
    }

    fetchHealthy();
  }, []);

  // Helper function to convert cents to dollars
  const centsToDollars = (cents) => {
    return (cents ).toFixed(2);
  };

  // Helper function to format plan name
  const formatPlanName = (plan) => {
    if (plan === 'monthly') return '1 Month';
    if (plan === 'quarterly') return '3 Months';
    return plan; // Fallback to original if unknown
  };

  // Helper function to check if promotion is still valid
  const isPromotionValid = (promo) => {
    if (!promo) return false;
    
    const now = new Date();
    
    // Check if promotion has started (valid_from)
    if (promo.valid_from) {
      const validFrom = new Date(promo.valid_from);
      if (now < validFrom) return false;
    }
    
    // Check if promotion has expired (valid_to)
    if (promo.valid_to) {
      const validTo = new Date(promo.valid_to);
      // Set time to end of day for valid_to comparison
      validTo.setHours(23, 59, 59, 999);
      if (now > validTo) return false;
    }
    
    return true;
  };

  return (
    <div className="page-content" style={{ backgroundColor: "#fdffa2ff" }}>
      <PageTitle parentTitle="Healthy" />

      <section className="content-inner">
        <div className="container">

           {loading && !error && (
              <div
                className="boxes"
                style={{ margin: "40px auto", width: "96px", height: "64px" }}
              >
                <div className="box">
                  <div></div>
                  <div></div>
                  <div></div>
                  <div></div>
                </div>
                <div className="box">
                  <div></div>
                  <div></div>
                  <div></div>
                  <div></div>
                </div>
                <div className="box">
                  <div></div>
                  <div></div>
                  <div></div>
                  <div></div>
                </div>
                <div className="box">
                  <div></div>
                  <div></div>
                  <div></div>
                  <div></div>
                </div>
              </div>
            )}

        {/* Display promotion badge - Terminal Style */}
        {!loading && !error && promotion && isPromotionValid(promotion) && (
          <div className="text-center mb-4" style={{ display: "flex", justifyContent: "center" }}>
            <style>{`
              .promotion-terminal-card {
                overflow: visible;
                border-radius: 20px;
                backdrop-filter: blur(800px);
                box-shadow: 0 0 60px 1px #ff9966;
                min-width: 344px;
                max-width: 500px;
                position: relative;
                z-index: 1;
              }
              .promotion-terminal-wrap {
                display: flex;
                flex-direction: column;
                gap: 1rem;
                position: relative;
                z-index: 10;
                border: 0.5px solid #525252;
                border-radius: 10px;
                overflow: hidden;
              }
              .promotion-terminal {
                display: flex;
                flex-direction: column;
                font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas,
                  "Liberation Mono", "Courier New", monospace;
              }
              .promotion-terminal-body {
                display: flex;
                flex-direction: column;
                position: relative;
                border-bottom-right-radius: 15px;
                border-bottom-left-radius: 15px;
                overflow-x: auto;
                line-height: 20px;
                color: white;
                background-color: black;
                white-space: nowrap;
              }
              .promotion-terminal-pre {
                display: flex;
                flex-direction: row;
                align-items: center;
                text-wrap: nowrap;
                white-space: pre;
                overflow: hidden;
                box-sizing: border-box;
                font-size: 16px;
              }
              .promotion-terminal-pre code:nth-child(1) {
                color: #ff9966;
              }
              .promotion-terminal-pre code:nth-child(2) {
                color: #ff9966;
              }
              .promotion-terminal-cmd {
                height: 19px;
                position: relative;
                display: flex;
                align-items: center;
                flex-direction: row;
              }
              .promotion-terminal-cmd::before {
                content: attr(data-cmd);
                position: relative;
                display: block;
                white-space: nowrap;
                overflow: hidden;
                background-color: transparent;
                animation: promotion-inputs 8s steps(22) infinite;
              }
              .promotion-terminal-cmd::after {
                content: "_";
                position: relative;
                display: block;
                height: 100%;
                overflow: hidden;
                background-color: transparent;
                border-right: 0.15em solid #ff9966;
                animation: promotion-cursor 0.5s step-end infinite alternate, promotion-blinking 0.4s infinite;
              }
              @keyframes promotion-blinking {
                20%, 80% {
                  transform: scaleY(1);
                }
                50% {
                  transform: scaleY(0);
                }
              }
              @keyframes promotion-cursor {
                50% {
                  border-right-color: transparent;
                }
              }
              @keyframes promotion-inputs {
                0%, 100% {
                  width: 0;
                }
                10%, 90% {
                  width: 58px;
                }
                30%, 70% {
                  width: 215px;
                  max-width: max-content;
                }
              }
            `}</style>
            <div className="promotion-terminal-card">
              <div className="promotion-terminal-wrap">
                <div className="promotion-terminal">
                  <div className="promotion-terminal-body">
                    <pre className="promotion-terminal-pre">
                      <code>-&nbsp;</code>
                      <code>NEW PROMOTION&nbsp;</code>
                      <code 
                        data-cmd={`${promotion.value}${typeof promotion.value === 'number' ? '%' : ''} ${promotion.type || ''}`.trim()}
                        className="promotion-terminal-cmd"
                      > 
                      </code>
                    </pre>
                   
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}

        {/* Display price plans at the top */}
        {!loading && !error && Object.keys(pricePlans).length > 0 && (
          <div
            className="price-plans"
            style={{
              marginBottom: "20px",
              textAlign: "center",
              maxWidth: "600px",
              marginLeft: "auto",
              marginRight: "auto",
              padding: "0 15px",
            }}
          >
            <ul
              style={{
                listStyle: "none",
                padding: 0,
                margin: 0,
                display: "flex",
                flexWrap: "wrap",
                justifyContent: "center",
                gap: "15px",
              }}
            >
              {Object.entries(pricePlans).map(([plan, price], index) => {
                const isEven = index % 2 === 0;
                const originalPrice = pricePlansOriginal[plan] || price;
                const hasDiscount = promotion && isPromotionValid(promotion) && originalPrice !== price;
                const discountAmount = originalPrice - price;

                return (
                  <li
                    key={plan}
                    style={{
                      backgroundColor: isEven ? "#d5d807ff" : "#000",
                      borderRadius: "8px",
                      padding: "10px 20px",
                      boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
                      minWidth: "120px",
                      flex: "1 1 120px",
                      maxWidth: "180px",
                      color: isEven ? "#000" : "#d5d807ff",
                      transition: "background-color 0.3s ease, color 0.3s ease",
                      cursor: "default",
                    }}
                  >
                    <strong>{formatPlanName(plan)}:</strong>
                    <br />
                    {hasDiscount ? (
                      <div>
                        <div style={{ marginBottom: "6px" }}>
                          <span
                            style={{
                              fontSize: "0.85rem",
                              textDecoration: "line-through",
                              opacity: 0.7,
                              display: "block",
                            }}
                          >
                            Old: ${centsToDollars(originalPrice)}
                          </span>
                          <span
                            style={{
                              fontSize: "1.3rem",
                              fontWeight: "bold",
                              display: "block",
                              marginTop: "2px",
                            }}
                          >
                            New: ${centsToDollars(price)}
                          </span>
                        </div>
                        <div
                          style={{
                            fontSize: "0.75rem",
                            marginTop: "4px",
                            padding: "2px 6px",
                            backgroundColor: isEven ? "rgba(220, 53, 69, 0.2)" : "rgba(255, 193, 7, 0.3)",
                            borderRadius: "4px",
                            color: isEven ? "#dc3545" : "#ffc107",
                            fontWeight: "600",
                          }}
                        >
                          Save ${centsToDollars(discountAmount)}
                        </div>
                      </div>
                    ) : (
                      <span style={{ fontSize: "1.2rem" }}>
                        ${centsToDollars(price)}
                      </span>
                    )}
                  </li>
                );
              })}
            </ul>
          </div>
        )}


          <div className="packages-grid">
            {!loading && !error && healthy.length > 0 ? (
              healthy.map((pkg) => (
                <div className="package-card" key={pkg.id}>
                  <img
                    src={pkg.images?.[0]?.url || IMAGES.placeholder}
                    alt={pkg.name}
                  />

                  <div className="package-card-body">
                    <div>
                      <h4>{pkg.name}</h4>
                      <p>{pkg.description}</p>
                    </div>

                    <button
                      onClick={(e) => handleViewDetails(e, pkg.id)}
                      className="btn btn-dark"
                    >
                      View Details
                    </button>
                  </div>
                </div>
              ))
            ) : (
              !loading &&
              !error && <p>No Healthy Packages available at the moment.</p>
            )}
          </div>
        </div>
      </section>

      <section className="call-action style-1 footer-action">
        <div className="container">
          <NewsLetter />
        </div>
      </section>
    </div>
  );
};

export default Healthy;
